var map = {
	"./base": 77,
	"./base.vue": 77,
	"./birthday": 358,
	"./birthday.vue": 358,
	"./custom-velaa": 359,
	"./custom-velaa.vue": 359,
	"./custom2021": 360,
	"./custom2021.vue": 360,
	"./custom2023": 366,
	"./custom2023-team1": 361,
	"./custom2023-team1.vue": 361,
	"./custom2023-team2": 362,
	"./custom2023-team2.vue": 362,
	"./custom2023-team3": 363,
	"./custom2023-team3.vue": 363,
	"./custom2023-team4": 364,
	"./custom2023-team4.vue": 364,
	"./custom2023-team5": 365,
	"./custom2023-team5.vue": 365,
	"./custom2023.vue": 366,
	"./devicedonation": 367,
	"./devicedonation.vue": 367,
	"./donate": 368,
	"./donate.vue": 368,
	"./icap": 369,
	"./icap.vue": 369,
	"./limited-education": 375,
	"./limited-education-2021": 374,
	"./limited-education-2021-group1": 370,
	"./limited-education-2021-group1.vue": 370,
	"./limited-education-2021-group2": 371,
	"./limited-education-2021-group2.vue": 371,
	"./limited-education-2021-group3": 103,
	"./limited-education-2021-group3.vue": 103,
	"./limited-education-2021-group4": 372,
	"./limited-education-2021-group4.vue": 372,
	"./limited-education-2021-group5": 373,
	"./limited-education-2021-group5.vue": 373,
	"./limited-education-2021.vue": 374,
	"./limited-education.vue": 375,
	"./phapa": 376,
	"./phapa.vue": 376,
	"./special-events": 377,
	"./special-events.vue": 377,
	"./uob": 390,
	"./uob-2023-default": 378,
	"./uob-2023-default.vue": 378,
	"./uob-2023-lovestory": 379,
	"./uob-2023-lovestory.vue": 379,
	"./uob-2023-set1": 380,
	"./uob-2023-set1.vue": 380,
	"./uob-2023-set2": 381,
	"./uob-2023-set2.vue": 381,
	"./uob-2023-set3": 382,
	"./uob-2023-set3.vue": 382,
	"./uob-2023-set4": 383,
	"./uob-2023-set4.vue": 383,
	"./uob-2024-ed-sheeran": 384,
	"./uob-2024-ed-sheeran.vue": 384,
	"./uob-2024-set-a": 385,
	"./uob-2024-set-a.vue": 385,
	"./uob-2024-set-b": 386,
	"./uob-2024-set-b.vue": 386,
	"./uob-2024-set-c": 387,
	"./uob-2024-set-c.vue": 387,
	"./uob-2024-set-combo": 388,
	"./uob-2024-set-combo.vue": 388,
	"./uob-default": 389,
	"./uob-default.vue": 389,
	"./uob.vue": 390
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 392;


//////////////////
// WEBPACK FOOTER
// ./src/components/templates/products ^\.\/.*$
// module id = 392
// module chunks = 1